module.exports = __webpack_public_path__ + "img/fill-input-2.5fea052b.jpg";